/* eslint-disable react-refresh/only-export-components -- bewusst co-lozierter Provider+Hook (Muster wie smart-search/context.tsx); react-refresh ist eine reine Dev-HMR-Optimierung. */
import { createContext, useCallback, useContext, useMemo, useState, type ReactNode } from 'react';

/**
 * Offen/zu-Zustand der globalen Sprachsteuerung.
 *
 * Eigener Provider, weil zwei weit auseinanderliegende Stellen ihn brauchen:
 * der Knopf in der TopBar und das Bedienfeld am unteren Bildschirmrand.
 */

interface SprachsteuerungContextValue {
  offen: boolean;
  setOffen: (offen: boolean) => void;
  umschalten: () => void;
}

const SprachsteuerungContext = createContext<SprachsteuerungContextValue | null>(null);

export function SprachsteuerungProvider({ children }: { children: ReactNode }) {
  const [offen, setOffen] = useState(false);
  const umschalten = useCallback(() => setOffen((o) => !o), []);
  const value = useMemo<SprachsteuerungContextValue>(
    () => ({ offen, setOffen, umschalten }),
    [offen, umschalten],
  );
  return (
    <SprachsteuerungContext.Provider value={value}>{children}</SprachsteuerungContext.Provider>
  );
}

export function useSprachsteuerung(): SprachsteuerungContextValue {
  const ctx = useContext(SprachsteuerungContext);
  if (!ctx) {
    throw new Error('useSprachsteuerung braucht einen <SprachsteuerungProvider> im Baum');
  }
  return ctx;
}
